import { on, bind } from './utils'
export default class FileInput {
	constructor (file, uploader) {
		this.uploader = uploader
		this.deleted = false
		this.file = file
		this.name = file.name
		this.mime = file.type
	}

	get value () {
		return this.file
	}

	remove(){
		this.deleted = true
		this.uploader.removeFile()
	}

	render() {
		return /*html*/`
		<div class="uploader-file">
			<span class="file-name">${this.name}</span>
			<span class="file-ext">${this.mime}</span>
		</div>
		<span class="remove" ${on('click', this, 'remove')} >usuń plik</span>`
	}
}
